import { ref, reactive } from 'vue';
import http from './http'

export default function useContacts() {
    const loading = ref(false);
    const clientData = ref();
    const clientList = ref();

    const subContractorData = ref();
    const subContractorList = ref();

    const attachments = ref([]);

    async function read() {
        await readClientList();
        await readSubContractorList();
    }

    async function readClientList() {
        loading.value = true;
        http.request('get', '/api/app/client/readlist').then((res) => {
            if (res?.Type == 200) {
                clientList.value = res.Data;
               
            }
        }).finally(() => {
            loading.value = false;
        });
    }

    function readSubContractorList() {
        loading.value = true;
        http.request('get', '/api/app/subcontractor/readlist').then((res) => {
            if (res?.Type == 200) {
                subContractorList.value = res.Data;

            }
        }).finally(() => {
            loading.value = false;
        });
    }

    function createClient(data, callback) {
         
        loading.value = true;
        http.request("post", '/api/app/client/create', data).then(res => {

            if (callback) {
                callback(res);
            }

             
        }).finally(() => {
            loading.value = false;
        });
    }
    function updateClient(data, callback) {
        loading.value = true;
        http.request("put", '/api/app/client/update', data).then(res => {

            if (callback) {
                callback(res);
            }
 
        }).finally(() => {
            loading.value = false;
        });
    }


    function createSubContractorWithProject(data, callback) {

        loading.value = true;
        http.request("post", '/api/app/subcontractor/createwithproject', data).then(res => {

            if (callback) {
                callback(res);
            }


        }).finally(() => {
            loading.value = false;
        });
    }

    function createSubContractor(data, callback) {

        loading.value = true;
        http.request("post", '/api/app/subcontractor/create', data).then(res => {

            if (callback) {
                callback(res);
            }


        }).finally(() => {
            loading.value = false;
        });
    }
    function updateSubContractor(data, callback) {
        loading.value = true;
        http.request("put", '/api/app/subcontractor/update', data).then(res => {

            if (callback) {
                callback(res);
            }

        }).finally(() => {
            loading.value = false;
        });
    }


    function saveAttachment(file, callback) {
        loading.value = true;
        if (file?.length) {
            return;
        }

        http.request("post", '/api/cloud/upload', file).then(res => {

            if (res?.Data != null) {
                //console.log("upload attachment file result ===>", res?.Data);
                if (callback) {
                    callback(res.Data);
                }
            } else {
                callback('');
            }
        }).finally(() => {
            
        });
    }

    return {
        read, loading, clientData, subContractorData, clientList, subContractorList, readClientList, readSubContractorList,
            createClient, updateClient, createSubContractor, updateSubContractor, createSubContractorWithProject,
        saveAttachment, attachments
    };
}
